import GoogleAnalyticsTracker from 'utils/shared/google_analytics_tracker.js'

# toolkit/form_elements#textarea__include-a-guide
$(document).on "click", ".js-toggle-textarea-guide", (e) ->
  wrapper = $(@).closest(".textarea-guide-header-wrapper")
  eventName = $(@).data("toggle-ga-event")
  wrapper.toggleClass("active")
  $(@).trigger("textareaGuide:toggled")
  if eventName.length > 0
    state = if wrapper.hasClass("active") then "active" else "inactive"
    GoogleAnalyticsTracker.event eventName, state



// WEBPACK FOOTER //
// ./app/javascript/lib/toolkit/behaviors/textarea.js.coffee